import { render } from "./EpharmaTemplate.vue?vue&type=template&id=0dba31f4"
import script from "./EpharmaTemplate.vue?vue&type=script&lang=js"
export * from "./EpharmaTemplate.vue?vue&type=script&lang=js"

import "./EpharmaTemplate.vue?vue&type=style&index=0&id=0dba31f4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__